import "core-js/modules/es.array.push.js";
import { userInfo, follow, unFollow } from '@/api/mg';
export default {
  data: function data() {
    return {
      userInfo: {},
      toUserId: '',
      status: '',
      isBack: true
    };
  },
  created: function created() {
    this.toUserId = this.$route.query.pid;
    this.status = this.$route.query.status;
    this.getUserInfo({
      pid: this.toUserId
    });
    this.isBack = localStorage.getItem('isBack');
  },
  methods: {
    toFollow: function toFollow(userId, item, str) {
      var _this = this;
      var params = {
        toUserId: userId
      };
      follow(params).then(function (res) {
        if (res.Code === 0) {
          _this.status = '0';
        } else {
          _this.$toast(res.Message);
        }
      });
    },
    toUnfollow: function toUnfollow(userId, item, str) {
      var _this2 = this;
      var params = {
        type: 1,
        id: userId
      };
      console.log(unFollow, 'params');
      unFollow(params).then(function (res) {
        if (res.Code === 0) {
          _this2.status = '2';
        } else {
          _this2.$toast(res.Message);
        }
      });
    },
    getUserInfo: function getUserInfo(params) {
      var _this3 = this;
      userInfo(params).then(function (res) {
        if (res.Code === 0) {
          _this3.userInfo = res.Data;
          console.log(res.Data, 'res.Data');
        } else {
          _this3.$toast(res.Message);
        }
      });
    },
    toAccount: function toAccount(userInfo) {
      // if (this.toUserId == localStorage.getItem('userId')) {
      //   this.$router.push({ path: '/me/account', query: { userInfo: JSON.stringify(userInfo) }})
      // }
    },
    back: function back() {
      this.$router.back();
    },
    toDetail: function toDetail(name, toUserId) {
      this.$router.push({
        path: '/me/detail',
        query: {
          str: name,
          toUserId: toUserId,
          from: 'detail'
        }
      });
    }
  }
};